import { gql, useMutation, useQuery } from '@apollo/client'

import {
  LotteryDeliveryInfoQuery,
  LotteryDeliveryInfoQueryVariables,
  UpdateUserDeliveryInfo,
  UpdateUserDeliveryInfoMutation,
  UpdateUserDeliveryInfoMutationVariables,
  UserDeliveryDetailFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { getPrefrenceObject } from '@/core/native/storage'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, routerPages, generatePath } =
    useRouter<{ preSaleId: string; clientId?: string; token?: string }>()
  const { data } = useQuery<
    LotteryDeliveryInfoQuery,
    LotteryDeliveryInfoQueryVariables
  >(QUERY)

  const [updateUserDeliveryInfo] = useMutation<
    UpdateUserDeliveryInfoMutation,
    UpdateUserDeliveryInfoMutationVariables
  >(UpdateUserDeliveryInfo)

  return {
    state: {
      user: data?.user ?? null,
    },
    actions: {
      async onSubmit(value) {
        await updateUserDeliveryInfo({
          variables: {
            updateUserDeliveryInfoInputs: {
              fullName: data?.user?.fullName ?? '',
              phoneNumber: data?.user?.phoneNumber ?? '',
              address: value,
            },
          },
        })

        const values = await getPrefrenceObject<{
          isFirstComeFirstServed?: boolean
        }>('preSaleLotteryApplicationInput')

        if (values?.isFirstComeFirstServed) {
          return router.replace(
            generatePath(routerPages.FirstComeFirstServedConfirmation, {
              preSaleId: router.query.preSaleId,
            })
          )
        }

        router.replace(
          generatePath(routerPages.LotteryConfirmation, {
            preSaleId: router.query.preSaleId,
          })
        )
      },
    },
  }
})

const QUERY = gql`
  query LotteryDeliveryInfo {
    user {
      ...UserDeliveryDetail
    }
  }
  ${UserDeliveryDetailFragmentDoc}
`
